import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {TableComponent} from '../../../components/table/table.component';
import {TableFunctionList} from '../../../entities/table-function-list.entity';
import {CustomTableFunctionTypeEnum} from '../../../enums/CustomTableFunctionTypeEnum';
import {TranslateService} from '@ngx-translate/core';
import {ContentHeaderService} from '../../../services/content-header.service';
import {TitleService} from '../../../services/title.service';
import {UserSessionService} from '../../../services/user-session.service';
import {Backend} from '@generated-backend-types';
import {AssignPatientToMeService} from '../../../services/api/patients/assign-patient-to-me.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import Patient = Backend.App.Resources.Dashboard.Patient;
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;

@Component({
  selector: 'app-authenticated-patients-index',
  templateUrl: './index.component.html',
  imports: [TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  private currentUserId?: string;
  private isBackofficeUser = false;
  public tableFunctionList: TableFunctionList = {
    custom: rowData => {
      const patient = rowData as Patient;

      if (patient.id && this.isBackofficeUser && patient?.backoffice_user?.id !== this.currentUserId) {
        return {
          type: CustomTableFunctionTypeEnum.BUTTON,
          value: this.translate.instant('authenticated.patients.index.assign_to_me.btn'),
          action: () => this.assignToMe(patient.id),
          iconClass: 'fa-square-plus'
        };
      }
      return;
    }
  }

  public constructor(
    protected override readonly cdr: ChangeDetectorRef,
    protected override readonly translate: TranslateService,
    protected override readonly contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    private readonly userSessionService: UserSessionService,
    private readonly assignPatientToMeService: AssignPatientToMeService,
    private readonly toastrService: ToastrService,
    private readonly router: Router,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }

  public ngOnInit() {
    this.titleService.setTitle('authenticated.patients.index.title');

    this.currentUserId = this.userSessionService.user$.value?.id;
    this.isBackofficeUser = this.userSessionService.hasAllRoles([RoleEnum.ADMIN]);
  }

  private assignToMe(patientId: string) {
    this.assignPatientToMeService.assignPatientToMe(patientId).subscribe({
      next: () => {
        this.toastrService.success(this.translate.instant('authenticated.patients.index.assign_to_me.success'));

        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate(['patients']).then());
      },
      error: () => this.toastrService.error(this.translate.instant('authenticated.patients.index.assign_to_me.error')),
    });
  }
}
